import { createTranslations } from '@momentum/i18n';
import { goalsEnTranslations } from './goals.en';

export const goalsHeTranslations = createTranslations(goalsEnTranslations, {
  // Page
  pageTitle: 'יעדים',

  // Tasks
  createGoalButton: 'יעד חדש',
  createGoalTitle: 'יעד חדש',
  createTask: 'משימה חדשה',

  // Create Goal Modal
  createTaskButton: 'משימה חדשה',
  createChildGoalTitle: 'צור/י יעד בן',
  addNestedGoal: 'הוסף/י תת-יעד',
  addNestedTask: 'הוסף/י משימה',
  addNestedItem: 'הוסף/י',
  addNestedGoalTooltip: 'צור/י יעד מקונן תחת יעד זה',
  addNestedItemTooltip: 'צור/י תת-יעד או משימה תחת יעד זה',
  createTaskTitle: 'משימה חדשה',

  // Update Goal Modal
  updateGoalTitle: 'עדכן/י יעד',
  updating: 'מעדכן...',
  updateGoal: 'עדכן/י יעד',

  // Update Task Modal
  updateTaskTitle: 'עדכן/י משימה',
  updateTask: 'עדכן/י משימה',

  // View Goal Modal
  viewGoalTitle: 'פרטי יעד',
  viewTaskTitle: 'פרטי משימה',

  // Delete Goal
  deleteGoal: {
    title: 'מחק/י יעד',
    description: (goalTitle: string) =>
      `האם אתה בטוח שברצונך למחוק את "${goalTitle}" ואת כל היעדים הבנים שלו? פעולה זו לא ניתנת לביטול.`,
    confirm: 'מחק/י',
    cancel: 'ביטול',
    deleting: 'מוחק...',
  },

  // Goal Form
  title: 'כותרת',
  description: 'תיאור (אופציונלי)',
  projectId: 'מזהה פרויקט',
  status: 'סטטוס',
  startDate: 'תאריך התחלה',
  dueDate: 'תאריך יעד',
  cancel: 'ביטול',
  creating: 'יוצר...',
  createGoal: 'יעד חדש',
  enrichGoal: 'העשר/י עם AI',
  enriching: 'מעשיר...',
  relevantSignals: 'סיגנלים רלוונטיים',
  loadingSignalSuggestions: 'מחפש סיגנלים רלוונטיים...',
  suggestedSignalsDescription:
    'מוצע לפי כותרת ותיאור. בטל/י סימון כדי לא לכלול במשימה.',
  includeSignalWithTask: 'כלול/י סיגנל זה במשימה',
  fromInteraction: 'מאינטראקציה',

  // View Goal Labels
  titleLabel: 'כותרת',
  descriptionLabel: 'תיאור',
  statusLabel: 'סטטוס',
  assigneesLabel: 'משתתפים',
  collaboratorsLabel: 'משתפי פעולה',
  parentGoalLabel: 'יעד אב',
  startDateLabel: 'תאריך התחלה',
  dueDateLabel: 'תאריך יעד',
  linkLabel: 'קישור',
  creatorLabel: 'בעלים',
  ownerLabel: 'בעלים',
  selectOwner: 'בחר בעלים',
  selectCreator: 'בחר יוצר',
  complete: 'הושלם',

  // Goals Tree View
  loadingGoals: 'טוען יעדים...',
  errorLoadingGoals: (error: string) => `שגיאה בטעינת יעדים: ${error}`,
  noGoalsFound: 'לא נמצאו יעדים',
  showCompleted: 'הצג יעדים ומשימות שהושלמו',
  filters: 'מסננים',
  filtersDescription: 'סנן יעדים ומשימות לפי עובד או סטטוס',
  filterByEmployee: 'סנן לפי עובד',

  // Goals Tree Header
  expandAll: 'הרחב הכל',
  collapseAll: 'כווץ הכל',

  // Key Results
  keyResultsLabel: 'מדדי ביצוע (אופציונלי)',
  keyResultsDescription: 'יש להגדיר תוצאות מדידות ליעד זה',
  addKeyResult: 'הוסף/י מדד ביצוע',
  addFirstKeyResult: 'הוסף/י מדד ביצוע ראשון',
  keyResult: 'מדד ביצוע',
  keyResultType: 'סוג מדד',
  selectKeyResultType: 'בחר/י סוג',
  maximumType: 'יעד להשגה (ערך גבוה יותר הוא טוב יותר)',
  minimumType: 'גבול עליון (ערך נמוך יותר הוא טוב יותר)',
  targetQuantity: 'כמות יעד',
  targetQuantityPlaceholder: 'לדוגמה: 1000',
  unit: 'יחידה',
  unitPlaceholder: 'לדוגמה: משתמשים, קליקים, %',
  currentProgress: 'התקדמות נוכחית',
  keyResultTitlePlaceholder: 'לדוגמה: הגדלת מעורבות משתמשים',
  noKeyResults: 'אין מדדי ביצוע עדיין',
  noKeyResultsDescription: 'הוסף/י תוצאות מדידות למעקב אחר התקדמות היעד',
  repeatableKeyResult: 'מדד ביצוע חוזר',
  recurrencePattern: 'דפוס חזרה',
  selectRecurrencePattern: 'בחר/י דפוס',
  recurrenceDaily: 'יומי',
  recurrenceWeekly: 'שבועי (כל 7 ימים)',
  recurrenceMonthly: 'חודשי',
  recurrenceCustom: 'מרווח מותאם אישית',
  intervalDays: 'חזרה כל (ימים)',
  viewHistory: 'הצג היסטוריה',

  // Repetitive Tasks
  repeatableTask: 'משימה חוזרת',
  repeatableTaskInfo:
    'המשימה תיצור אוטומטית מופעים חדשים על פי הדפוס עד תאריך היעד של המשימה',
  yes: 'כן',
  no: 'לא',
  taskOccurrenceHistory: 'היסטוריית מופעי משימה',
  recurrenceStartDate: 'תאריך התחלת חזרה',
  recurrenceEnd: 'סיום חזרה',
  noEndDate: 'ללא תאריך סיום',
  endAfterOccurrences: 'סיום לאחר X מופעים',
  repeatUntilDate: 'חזרה עד תאריך מסוים',
  numberOfOccurrences: 'מספר מופעים',
  endDate: 'תאריך סיום',
  occurrenceHistory: 'היסטוריית מופעים',
  currentOccurrence: 'מופע נוכחי',
  pastOccurrences: 'מופעים קודמים',
  currentBadge: 'נוכחי',
  started: 'התחלה',
  progress: 'התקדמות',
  period: 'תקופה',
  completed: 'הושלם',
  noHistory: 'אין היסטוריה עדיין',
  noHistoryDescription: 'ההיסטוריה תופיע כאשר יהיו מופעי עבר שהסתיימו',
  closeEntireTask: 'המשימה הושלמה במלואה',
  closing: 'סוגר...',
  taskHasClosed: 'משימה זו נסגרה - לא ייווצרו מופעים חדשים',
  reopenTask: 'פתח מחדש משימה',
  reopening: 'פותח מחדש...',

  // Recurring task completion
  occurrenceCompleted: 'מופע הושלם',
  occurrenceCompletedDescription: (nextDate: string) =>
    `מופע זה הושלם. המופע הבא מתחיל ב-${nextDate}.`,
  nextOccurrenceStarts: (date: string) => `הבא: ${date}`,
  occurrenceMarkedComplete: 'סומן כהושלם',
  occurrenceMarkedIncomplete: 'סומן כלא הושלם',
  deleteOccurrence: 'מחק',
  deleteOccurrenceSuccess: 'המופע נמחק',

  // Stop recurrence
  stopRecurrence: 'עצור את כל המופעים העתידיים',
  stopRecurrenceWarning:
    'פעולה זו תעצור לצמיתות את החזרתיות. לא ייווצרו מופעים חדשים.',
  recurrencePermanentlyStopped: 'החזרתיות הופסקה לצמיתות.',

  // Recurrence patterns
  repeatsDaily: 'חוזר יומית',
  repeatsWeekly: 'חוזר שבועית',
  repeatsMonthly: 'חוזר חודשית',
  repeatsCustom: (days: number) => `חוזר כל ${days} ימים`,

  // Recurrence badge labels (short, for inline badge)
  badgeDaily: 'יומי',
  badgeWeekly: 'שבועי',
  badgeMonthly: 'חודשי',
  badgeCustom: 'מותאם',

  // Recurrence metadata line
  dueLabel: (date: string) => `עד: ${date}`,
  currentDone: 'הושלם',
  nextLabel: (date: string) => `הבא: ${date}`,

  // Parent Goal Selector
  selectParentGoal: 'בחר יעד אב',
  noParentGoal: 'ללא יעד אב',

  // Status
  statusCompleted: 'הושלם',
  statusInProgress: 'בתהליך',
  statusTodo: 'לביצוע',
  statusUnknown: 'לא ידוע',
  failedToUpdateStatus: 'עדכון סטטוס נכשל',
  couldNotUpdateGoalStatus: 'לא ניתן לעדכן את סטטוס היעד. אנא נסה שוב.',

  // Goal Card
  fromSubGoals: (count: number) => `• ${count} מיעדי משנה`,
  fromSubGoalsLabel: (count: number) => `${count} מיעדי משנה`,
  interactionsLabel: 'אינטראקציות',
  blockagesLabel: (count: number) =>
    count === 1 ? `חסימה ${count}` : `חסימות ${count}`,
  goalTypeLabel: 'יעד על',
  taskTypeLabel: 'משימה',

  // Empty State
  createFirstGoal: 'צור/י את היעד הראשון שלך כדי להתחיל',

  // AI Enrichment
  noRelevantSignals: 'לא נמצאו סיגנלים רלוונטיים',

  // Interactions
  interactions: {
    title: 'אינטראקציות יעד',
    description: (goalTitle: string) =>
      `כל האינטראקציות הקשורות ל-"${goalTitle}"`,
    loading: 'טוען אינטראקציות...',
    empty: 'לא נמצאו אינטראקציות ליעד זה',
    sender: 'מאת',
    receiver: 'אל',
    status: 'סטטוס',
    coreParticipants: 'משתתפים מרכזיים',
    otherParticipants: 'משתתפים אחרים',
    interactionTypeISeeYou: 'I See You',
    interactionTypeINeedYou: 'I Need You',
    interactionTypeILearn: 'I Learn',
    blockage: 'חסימה',
    goalLabel: 'יעד:',
  },

  // Tasks Table
  tasksTable: {
    headerStatus: 'סטטוס',
    headerTask: 'משימה',
    headerAssignees: 'משתתפים',
    headerStartDate: 'תאריך התחלה',
    headerDueDate: 'תאריך יעד',
    headerFinishDate: 'תאריך סיום',
    headerActions: 'פעולות',
    headerInteractions: 'אינטראקציות',
    noTasksYet: 'אין משימות עדיין',
    taskCount: (count: number) =>
      count === 1 ? `${count} משימה` : `${count} משימות`,
    completed: 'הושלמו',
    inProgress: 'בתהליך',
    percentComplete: (percent: number) => `${percent}% הושלם`,
  },

  // KPI Progress Update
  kpi: {
    updateProgress: 'עדכון התקדמות',
    setProgressFor: (title: string) => `קבע/י התקדמות עבור ${title}`,
    updateProgressButton: 'עדכן/י התקדמות',
    updating: 'מעדכן...',
    progressUpdated: 'ההתקדמות עודכנה',
    progressUpdatedDescription: (
      title: string,
      progress: number,
      unit: string
    ) => `התקדמות ${title} עודכנה ל-${progress} ${unit}`,
    invalidValue: 'ערך לא תקין',
    invalidValueDescription: 'אנא הכנס/י מספר חיובי תקין',
    cannotBeNegative: 'ההתקדמות לא יכולה להיות שלילית',
    updateFailed: 'העדכון נכשל',
    updateFailedDescription: 'נכשל עדכון התקדמות מדד הביצוע. אנא נסה/י שוב.',
    maxValue: 'מקסימום',
  },

  // Import
  import: 'ייבוא',
  importSources: 'מקורות ייבוא',
  selectImportSource: 'בחר/י מקור לייבוא מטרות ומשימות',
  msProjectTitle: 'Microsoft Project',
  importFromMsProject: 'ייבוא מקובץ XML',

  // MS Project Import
  importMsProject: 'ייבוא מ-MS Project',
  importing: 'מייבא...',
  importSuccess: 'הייבוא הצליח',
  importSuccessDescription: 'קובץ ה-MS Project יובא בהצלחה.',
  goalsCreated: 'מטרות שנוצרו',
  tasksCreated: 'משימות שנוצרו',
  totalItems: 'סך הכל פריטים',
  close: 'סגור',
  importError: {
    title: 'הייבוא נכשל',
    generic: 'נכשל ייבוא קובץ MS Project. אנא נסה/י שוב.',
    invalidFileType: 'אנא בחר/י קובץ XML תקין ממיקרוסופט פרויקט.',
  },

  // Excel Export
  exportToExcel: 'ייצוא לאקסל',
  exporting: 'מייצא...',
  excelColumnIdx: 'מס׳',
  excelColumnTitle: 'כותרת',
  excelColumnOwner: 'בעלים',
  excelColumnAssignees: 'משתתפים',
  excelColumnStartTime: 'תאריך התחלה',
  excelColumnEndTime: 'תאריך סיום',
  excelColumnDuration: 'משך',
  excelColumnActualEndDate: 'תאריך סיום בפועל',
  excelColumnRemarks: 'הערות',
  excelHeaderCreator: 'יוצר',
  excelHeaderExportDate: 'תאריך ייצוא',
  excelHeaderGoalDueDate: 'תאריך יעד למטרה',
  // Restricted Goal
  restrictedGoal: {
    title: 'יעד פרטי',
    description: 'אין לך הרשאה לצפות ביעד זה',
  },

  // Viewers
  viewers: 'צופים',
  selectViewers: 'בחר צופים',
  searchEmployees: 'חפש עובדים...',
  noEmployeesFound: 'לא נמצאו עובדים',
  selectionCount: (count: number) =>
    count === 1 ? `צופה ${count} נבחר` : `צופים ${count} נבחרו`,

  // Privacy
  privacy: 'פרטיות',
  private: 'פרטי',
  public: 'ציבורי',
  publicCompanyWide: 'ציבורי (כלל החברה)',
  visibleToAllInCompany: 'נראה לכל המשתמשים בחברה שלך',
  publicDescription: 'הפוך את היעד הזה לגלוי לכל החברה',
  privateDescription: 'הצג את היעד הזה רק לבעלים ומשתתפים',
  editingSingleOccurrence: 'עריכה של מופע זה בלבד. סדרת החזרה תמשיך ללא שינוי.',

  // Integrations Dialog
  integrationsDialog: {
    title: 'מרכז אינטגרציות',
    description: 'חבר ונהל את כלי הפרויקט שלך',
    activeConnections: 'חיבורים פעילים',
    addIntegration: 'הוסף אינטגרציה',
    connected: 'מחובר',
    noOtherIntegrations: 'אין אינטגרציות מחוברות',
    noOtherIntegrationsDescription:
      'חבר את כלי ניהול הפרויקטים שלך כדי לסנכרן משימות ויעדים.',
    browseIntegrations: 'עיין באינטגרציות',
    connectMoreTools: 'חבר כלים נוספים',
    searchPlaceholder: 'חפש אינטגרציות...',
    jira: 'Jira',
    jiraDescription: 'סנכרן משימות ואפיקים',
    linear: 'Linear',
    linearDescription: 'עקוב אחר משימות ופרויקטים',
    monday: 'Monday',
    mondayDescription: 'נהל עבודה ופרויקטים',
    salesforce: 'Salesforce',
    salesforceDescription: 'התאם CRM ליעדים',
    bamboohr: 'BambooHR',
    bamboohrDescription: 'סנכרן נתוני עובדים',
    sharepoint: 'SharePoint',
    sharepointDescription: 'גישה וסנכרון מסמכי SharePoint',
    dynamicsCrm: 'Dynamics CRM',
    dynamicsCrmDescription: 'סנכרן נתוני CRM עם יעדים',
    confluence: 'Confluence',
    confluenceDescription: 'גישה וסנכרון דפי Confluence',
    crmConnectTitle: 'חיבור Dynamics CRM',
    crmConnectDescription:
      'הזן את כתובת ה-URL של ארגון Dynamics CRM שלך כדי לחבר את המופע.',
    crmUrlPlaceholder: 'yourorg.crm4',
    crmUrlHelper: 'הזן את שם הארגון והאזור (לדוגמה yourorg.crm, yourorg.crm4).',
    crmUrlPrefix: 'https://',
    crmUrlSuffix: '.dynamics.com',
    continue: 'המשך',
    syncPlansAndTimelines: 'סנכרן תוכניות ולוחות זמנים',
    installed: 'מותקן',
    comingSoon: 'בקרוב',
    disconnect: 'ניתוק',
    disconnecting: 'מנתק...',
    cancel: 'ביטול',
    aiConnections: 'כלי AI',
    aiConnectionsDescription:
      'חבר כלים שה-AI יכול להשתמש בהם בעת ניתוח רלוונטיות סיגנלים',
    aiConnect: 'חבר',
    aiConnected: 'מחובר',
    aiToolkits: {
      jira: {
        name: 'Jira (AI)',
        description:
          'אפשר ל-AI לחפש משימות Jira קשורות להתאמת סיגנלים טובה יותר',
      },
      share_point: {
        name: 'SharePoint (AI)',
        description:
          'אפשר ל-AI לחפש קבצים ותוכן ב-SharePoint להתאמת סיגנלים טובה יותר',
      },
      confluence: {
        name: 'Confluence (AI)',
        description:
          'אפשר ל-AI לחפש דפים ותוכן ב-Confluence להתאמת סיגנלים טובה יותר',
      },
    },
  },

  // Integrations
  integrations: {
    connectedIntegrations: 'אינטגרציות מחוברות',
    manageAndSync: 'נהל את אינטגרציות הפרויקט שלך',
    addAnotherIntegration: 'הוסף אינטגרציה נוספת',
    noIntegrations: 'אין אינטגרציות',
    noIntegrationsDescription:
      'חבר Jira או כלי ניהול פרויקטים אחרים כדי לסנכרן את המשימות והיעדים שלך.',
    connectIntegration: 'חבר אינטגרציה',
    connecting: 'מתחבר...',
    integrations: 'אינטגרציות',
    syncIssues: 'סנכרן משימות',
    syncing: 'מסנכרן...',
    syncSuccess: (totalIssues: number, provider: string) =>
      `${totalIssues} משימות סונכרנו מ-${provider} בהצלחה!`,
    syncFailed: (provider: string) => `נכשל סנכרון משימות מ-${provider}`,
    disconnectConfirm: (provider: string) =>
      `האם אתה בטוח שברצונך לנתק את אינטגרציית ${provider}?`,
    disconnectSuccess: (provider: string) => `אינטגרציית ${provider} נותקה`,
    disconnectFailed: (provider: string) => `נכשל ניתוק אינטגרציית ${provider}`,
    connectWebhook: 'חבר Webhook',
    reconnectWebhook: 'חבר מחדש Webhook',
    registeringWebhook: 'מחבר webhook...',
    webhookRegistered: 'Webhook נרשם בהצלחה',
    webhookFailed: 'נכשלה רישום webhook',
  },
});
